import Tag from 'honeydew/Tag';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';

export function MembershipDescriptions() {
    const {
        availableTrialMembership,
        plusMembershipBranding,
        price: { annual: annualPrice } = {},
    } = useAccountPlusMembershipHook();
    const trialDurationDays = availableTrialMembership?.trialDurationDays;

    const plusMembershipPerks = [
        'Your payment method will be charged the full annual fee on signup',
        'Your annual membership will automatically renew (but we’ll email you a reminder beforehand!)',
    ];

    const trialMembershipPerks = [
        `Enjoy all the ${plusMembershipBranding} benefits free for ${trialDurationDays} days, risk-free`,
        'Don’t worry, we’ll remind you when your free trial is ending',
        'When your free trial ends, we’ll automatically charge you the annual fee so you can continue saving more all year long!',
    ];

    return (
        <>
            <div>
                {trialDurationDays && (
                    <Tag bgColor="plusMembership">
                        <span className="uppercase">Try it free for {trialDurationDays} days</span>
                    </Tag>
                )}
                <span className="mt-5 flex pb-5">
                    <p className="font-grotesk-bold">${annualPrice} per year&nbsp;</p>
                    <p className="mt-[2px]">| Billed annually</p>
                </span>
            </div>
            <ul className="list-disc pl-20">
                {(trialDurationDays ? trialMembershipPerks : plusMembershipPerks).map((perk) => (
                    <li key={perk}>{perk}</li>
                ))}
            </ul>
            <div className="text-body-sm rounded-md bg-off-white px-20 py-10 text-center">
                Your {plusMembershipBranding} annual fee <b className="font-grotesk-bold">pays for itself</b> with just
                one order per month*
            </div>
        </>
    );
}
